import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/translatorDefaultPhoto.png'
import _imports_1 from '@/assets/images/phone.svg'
import _imports_2 from '@/assets/images/mail-outline.svg'
import _imports_3 from '@/assets/images/pointer.svg'
import _imports_4 from '@/assets/images/access-time.svg'
import _imports_5 from '@/assets/icons/marker.svg'


const _withScopeId = n => (_pushScopeId("data-v-fe2d092e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto pb-0 xl:pb-4 px-4 xl:pt-20 pt-10" }
const _hoisted_2 = {
  tabindex: "0",
  class: "flex justify-between items-start w-full"
}
const _hoisted_3 = { class: "flex md:items-center flex-wrap flex-col md:flex-row" }
const _hoisted_4 = { class: "text-4xl md:text-5xl md:pr-7 pb-4 xl:pb-0 break-words break-word-custom" }
const _hoisted_5 = { class: "flex items-center pb-4 xl:pb-0 flex-wrap" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["alt"]
const _hoisted_8 = {
  key: 3,
  class: "pr-5"
}
const _hoisted_9 = {
  key: 4,
  class: "pt-1 pb-1 pl-2 pr-2 bg-black-100 text-white rounded-lg"
}
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = ["alt"]
const _hoisted_12 = {
  tabindex: "0",
  class: "pb-4"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_14 = { class: "text-light-secondary" }
const _hoisted_15 = { class: "flex flex-col-reverse md:flex-row md:items-center lg:items-baseline" }
const _hoisted_16 = { class: "flex flex-wrap-reverse" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["alt"]
const _hoisted_19 = { class: "break-words break-word-custom text-sm" }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["alt"]
const _hoisted_22 = { class: "break-words break-word-custom text-sm" }
const _hoisted_23 = {
  key: 2,
  tabindex: "0",
  class: "flex text-light-secondary self-center w-full xl:w-auto pb-5 xl:pb-0 items-center"
}
const _hoisted_24 = ["alt"]
const _hoisted_25 = { class: "break-words break-word-custom text-sm" }
const _hoisted_26 = { class: "flex pb-4 lg:hidden flex-wrap" }
const _hoisted_27 = { class: "bg-grey-200" }
const _hoisted_28 = { class: "container mx-auto pt-6 pb-10 flex justify-between px-4" }
const _hoisted_29 = {
  key: 0,
  tabindex: "0",
  class: "bg-black-100 text-white p-6 w-full mb-2 text-center"
}
const _hoisted_30 = { class: "break-words" }
const _hoisted_31 = {
  key: 1,
  tabindex: "0",
  class: "bg-white p-6 w-full mb-2"
}
const _hoisted_32 = { class: "font-bold text-2xl pb-4 break-words" }
const _hoisted_33 = { class: "break-words" }
const _hoisted_34 = {
  key: 2,
  tabindex: "0",
  class: "bg-white p-6 w-full mb-2"
}
const _hoisted_35 = { class: "flex flex-col md:flex-row items-center gap-2.5" }
const _hoisted_36 = { class: "pb-4 md:pb-0" }
const _hoisted_37 = { class: "break-words font-bold" }
const _hoisted_38 = {
  key: 3,
  tabindex: "0",
  class: "bg-white p-6 w-full mb-2"
}
const _hoisted_39 = { class: "font-bold text-2xl pb-4 break-words" }
const _hoisted_40 = { class: "break-words whitespace-pre-line" }
const _hoisted_41 = {
  key: 4,
  tabindex: "0",
  class: "bg-white p-6 w-full mb-2"
}
const _hoisted_42 = { class: "font-bold text-2xl pb-4 break-words" }
const _hoisted_43 = { class: "font-bold pb-2" }
const _hoisted_44 = { class: "pb-2 break-words" }
const _hoisted_45 = { class: "text-light-secondary pr-3" }
const _hoisted_46 = {
  key: 5,
  tabindex: "0",
  class: "bg-white p-6 w-full mb-2"
}
const _hoisted_47 = { class: "font-bold text-2xl pb-4 break-words" }
const _hoisted_48 = { class: "font-bold pb-2" }
const _hoisted_49 = { class: "pb-2 break-words" }
const _hoisted_50 = { class: "text-light-secondary pr-3" }
const _hoisted_51 = { class: "flex sm:items-center pb-4 flex-col sm:flex-row" }
const _hoisted_52 = { class: "font-bold text-2xl pr-4 pb-2 sm:pb-0 break-words" }
const _hoisted_53 = { class: "flex items-center flex-wrap" }
const _hoisted_54 = { class: "text-light-secondary pr-4 pb-2 sm:pb-0" }
const _hoisted_55 = {
  key: 0,
  class: "flex text-light-secondary items-center flex-wrap pb-2 sm:pb-0"
}
const _hoisted_56 = ["alt"]
const _hoisted_57 = { class: "flex sm:justify-between flex-col sm:flex-row" }
const _hoisted_58 = {
  key: 0,
  class: "flex-1 pb-4 sm:pb-0"
}
const _hoisted_59 = { class: "font-bold pb-2" }
const _hoisted_60 = { class: "list-disc pl-6" }
const _hoisted_61 = {
  key: 1,
  class: "flex-1"
}
const _hoisted_62 = { class: "font-bold pb-2" }
const _hoisted_63 = { class: "info_window translator-card md:flex bg-white --alternativeLook font-sans" }
const _hoisted_64 = { class: "info_content" }
const _hoisted_65 = { class: "flex translator-card-row md:items-center flex-wrap gap-3 flex-nowrap" }
const _hoisted_66 = { class: "flex items-center self-baseline" }
const _hoisted_67 = ["src", "alt"]
const _hoisted_68 = ["alt"]
const _hoisted_69 = { class: "flex flex-col" }
const _hoisted_70 = { class: "flex self-baseline flex-nowrap flex-col md:flex-row md:items-start items-center" }
const _hoisted_71 = { class: "font-bold text-1xl pb-3 w-full break-words md:mr-2" }
const _hoisted_72 = {
  key: 0,
  class: "flex pb-3 items-center"
}
const _hoisted_73 = ["aria-label"]
const _hoisted_74 = {
  key: 2,
  class: "pt-1 pb-1 pl-2 pr-2 bg-black-100 text-white rounded-lg"
}
const _hoisted_75 = { class: "flex items-start content-start gap-2 flex-row flex-wrap flex-col items-start" }
const _hoisted_76 = { class: "font-bold pr-4" }
const _hoisted_77 = {
  key: 0,
  class: "flex items-center flex-wrap"
}
const _hoisted_78 = {
  key: 0,
  class: "pr-4"
}
const _hoisted_79 = {
  key: 1,
  class: "flex items-center gap-2 flex-wrap"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_81 = { class: "flex items-center pt-3 pl-1" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "pr-3"
}, null, -1))
const _hoisted_83 = { class: "text-xs" }

import {onMounted, Ref, ref, watch, withDefaults} from 'vue';
import ButtonPrimary from '@/components/atoms/ButtonPrimary.vue';
import StarsCounter from '@/components/atoms/StarsCounter.vue'
import axios from "axios";
import ApiHelper from "@/helpers/apiHelper";
import router, {getRouteName} from "@/router";
import moment from "moment";
import SendInquiriesModal from "@/components/translator/inquiries/sendInquiriesModal.vue";
import authHelper from "@/helpers/authHelper";
import i18n from "@/i18n";
import {useAuthStore} from "@/stores/authStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'TranslatorPage',
  props: {
    isModal: { type: Boolean, default: false },
    nameSlug: null,
    tpNumberSlug: null
  },
  setup(__props: any) {

const props = __props as { isModal: boolean, nameSlug?: string, tpNumberSlug?: string }



const translator: Ref<any> = ref({}),   isLoading = ref(false),
    showAllAboutMe = ref(false),
    showAllExperience = ref(false),
    experiencesShowLimit = 2,
    aboutMeLimit = 250,
    showTranslatorRequestModal = ref(false),
    auth = authHelper,
    authStore = useAuthStore();

function cancel(close) {
    showTranslatorRequestModal.value = false;
}

async function getUseData() {

    await authStore.getUser()
}
if(authStore.user == '')
    getUseData();

async function fetchTranslatorData() {
    isLoading.value = true;

    let nameSlug = '';
    let tpNumberSlug = '';
    if (props.isModal) {
        nameSlug = props.nameSlug ?? '';
        tpNumberSlug = props.tpNumberSlug ?? '';
    } else {
        nameSlug = router?.currentRoute?.value?.params?.nameSlug?.toString() ?? '';
        tpNumberSlug = router?.currentRoute?.value?.params?.tpNumberSlug?.toString() ?? '';
    }
    await axios.get(ApiHelper.getTranslatorDataUrl(nameSlug, tpNumberSlug)
    ).then(result => {
        translator.value = result.data;
        isLoading.value = false;

    }).catch(() => {
        isLoading.value = false;
        router.push({name: getRouteName('home')})
    });
}

function getTranslationLanguages(languagesArray) {
    let langsString = '';
    if (languagesArray && languagesArray.length > 0) {
        languagesArray.forEach((elem, index) => {
            if (langsString)
                langsString += ', ';
            langsString += elem.name
        })
    }

    return langsString;
}

function getAboutMeContent() {
    if (translator.value?.advanceInfo?.aboutMe) {
        if (showAllAboutMe.value || translator.value?.advanceInfo?.aboutMe.length <= aboutMeLimit)
            return translator.value?.advanceInfo?.aboutMe;
        else
            return (translator.value?.advanceInfo?.aboutMe).substring(0, 200) + '...'
    }
    return '';
}

function getTranslatorExperiencesArray() {
    if (translator.value && translator.value?.advanceInfo?.experiences) {
        if (showAllExperience.value)
            return translator.value?.advanceInfo?.experiences;
        else
            return translator.value?.advanceInfo?.experiences.slice(0, experiencesShowLimit);
    }

    return [];
}

function getExperienceDate(dateFrom, dateTo) {
    let dateString = '';
    if (dateFrom) {
        dateString += moment(dateFrom).format('DD.MM.YYYY');
    }
    if (dateTo) {
        if (dateString)
            dateString += ' - '
        dateString += moment(dateTo).format('DD.MM.YYYY');
    } else {
        if (dateString)
            dateString += ' - '
        dateString += i18n.global.t('translatorPage.currently')
    }
    return dateString;
}

function getEducationDate(dateFrom, dateTo) {
    let dateString = '';
    if (dateFrom) {
        dateString += moment(dateFrom).format('YYYY');
    }
    if (dateTo) {
        if (dateString)
            dateString += ' - '
        dateString += moment(dateTo).format('YYYY');
    }
    return dateString;
}

function ucfirst(stringText) {
    return stringText.charAt(0).toUpperCase() + stringText.slice(1);
}


//Maps
const center = ref({
    lat: 0,
    lng: 0,
}),
    myMapRef = ref(),
    map = ref(),
    marker = ref({
        id: 0,
        position: {
            lat: 0,
            lng: 0,
        },
        icon: require('../assets/icons/map_icon_outline.png'),
    }),

    openedMarkerID = ref(0),
    chooseList = ref(true),
    chooseMap = ref(false);

function openMarker(id) {
    openedMarkerID.value = id;
    setTimeout(() => {
        if(document.querySelector('.gm-style-iw > button'))
            document.querySelector('.gm-style-iw > button')!.style.display = 'none';
    },1);
    marker.value.icon = require('../assets/icons/map_icon_fill.png');
}

function closeInfo(id) {
    marker.value.icon = require('../assets/icons/map_icon_outline.png');
    openedMarkerID.value = 0;
}


//TODO do zmiany bo nie moze byc tyle ifów odnosmie bounds
watch(translator, (curr: {address: {lat: number, lng: number}, basicInfo: {id: number}}, old) => {
    marker.value.position.lat = curr?.address?.lat;
    marker.value.position.lng = curr?.address?.lng;
    marker.value.id = curr?.basicInfo.id;
    center.value.lat = curr?.address?.lat;
    center.value.lng = curr?.address?.lng;
});


onMounted( () => {
    myMapRef.value.$mapPromise.then((mapObject: any) => {
        map.value = mapObject;
        fetchTranslatorData();
    });


})



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GMapInfoWindow = _resolveComponent("GMapInfoWindow")!
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(translator.value?.basicInfo?.name), 1),
          _createElementVNode("div", _hoisted_5, [
            (translator.value?.basicInfo?.profileImgUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: translator.value?.basicInfo?.profileImgUrl,
                  alt: _ctx.$t('translatorPage.translatorImageAlt'),
                  class: "translator-image-small xl:hidden block self-baseline mr-5"
                }, null, 8, _hoisted_6))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _imports_0,
                  alt: _ctx.$t('translatorPage.translatorImageAlt'),
                  class: "translator-image-small xl:hidden block self-baseline mr-5"
                }, null, 8, _hoisted_7)),
            (translator.value?.basicInfo?.hasAccount && translator.value?.basicInfo?.stars)
              ? (_openBlock(), _createBlock(StarsCounter, {
                  key: 2,
                  stars: translator.value?.basicInfo?.stars,
                  class: "pr-2"
                }, null, 8, ["stars"]))
              : _createCommentVNode("", true),
            (translator.value?.basicInfo?.hasAccount && translator.value?.basicInfo?.successfulOrders)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(translator.value?.basicInfo?.successfulOrders) + ") ", 1))
              : _createCommentVNode("", true),
            (translator.value?.basicInfo?.hasAccount && translator.value?.basicInfo?.isVip)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "VIP"))
              : _createCommentVNode("", true)
          ])
        ]),
        (translator.value?.basicInfo?.profileImgUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: translator.value?.basicInfo?.profileImgUrl,
              alt: _ctx.$t('translatorPage.translatorImageAlt'),
              class: "translator-image xl:block hidden self-baseline"
            }, null, 8, _hoisted_10))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_0,
              alt: _ctx.$t('translatorPage.translatorImageAlt'),
              class: "translator-image xl:block hidden self-baseline"
            }, null, 8, _hoisted_11))
      ]),
      _createElementVNode("p", _hoisted_12, [
        _createTextVNode(_toDisplayString(_ctx.$t('translatorPage.translationLanguages')) + ": " + _toDisplayString(getTranslationLanguages(translator.value?.languages)) + " ", 1),
        _hoisted_13,
        _createTextVNode(),
        _createElementVNode("span", _hoisted_14, _toDisplayString(translator.value?.basicInfo?.tpNumber), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_unref(authStore)?.user?.translatorId != translator.value?.basicInfo?.id && !_unref(authHelper).isTranslatorOrVipTranslator())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (translator.value?.basicInfo?.hasAccount && translator.value?.advanceInfo?.hasActiveInbox && _unref(auth).isLogged())
                ? (_openBlock(), _createBlock(ButtonPrimary, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (!translator.value?.advanceInfo?.absence?.isAbsence ? showTranslatorRequestModal.value = true : '')),
                    name: _ctx.$t('translatorPage.askForOffer'),
                    class: _normalizeClass(["md:mr-5 mb-4 w-full md:w-auto", {
                                   '--disabled': translator.value?.advanceInfo?.absence?.isAbsence
                               }])
                  }, null, 8, ["name", "class"]))
                : (translator.value?.basicInfo?.hasAccount && translator.value?.advanceInfo?.hasActiveInbox)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      class: "btn-primary md:mr-5 mb-4 w-full md:w-auto",
                      to: {name: _unref(getRouteName)('login')}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('translatorPage.askForOffer')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          (translator.value?.basicInfo?.phone)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                tabindex: "0",
                href: 'tel:' + translator.value?.basicInfo?.phone,
                class: "flex pr-5 text-light-secondary self-center pb-5 xl:pb-0 items-center"
              }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: _ctx.$t('translatorPage.phoneIconAlt'),
                  class: "pr-2 self-baseline translator-page-phone my-auto"
                }, null, 8, _hoisted_18),
                _createElementVNode("span", _hoisted_19, _toDisplayString(translator.value?.basicInfo?.phone), 1)
              ], 8, _hoisted_17))
            : _createCommentVNode("", true),
          (translator.value?.basicInfo?.email)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                tabindex: "0",
                href: 'mailto:' + translator.value?.basicInfo?.email,
                target: "_blank",
                class: "flex pr-5 text-light-secondary self-center pb-5 xl:pb-0 items-center"
              }, [
                _createElementVNode("img", {
                  src: _imports_2,
                  alt: _ctx.$t('translatorPage.mailIconAlt'),
                  class: "pr-2 self-baseline translator-page-email my-auto"
                }, null, 8, _hoisted_21),
                _createElementVNode("span", _hoisted_22, _toDisplayString(translator.value?.basicInfo?.email), 1)
              ], 8, _hoisted_20))
            : _createCommentVNode("", true),
          (translator.value?.address?.fullAddress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "pr-2 self-baseline translator-page-pointer my-auto",
                  alt: _ctx.$t('translatorPage.pointerIconAlt')
                }, null, 8, _hoisted_24),
                _createElementVNode("p", _hoisted_25, _toDisplayString(translator.value?.address?.fullAddress), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(ButtonPrimary, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => {chooseList.value = true; chooseMap.value = false}),
          name: _ctx.$t('translatorPage.list'),
          class: "w-full flex-1",
          outlined: "",
          disabled: chooseMap.value
        }, null, 8, ["name", "disabled"]),
        _createVNode(ButtonPrimary, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => {chooseList.value = false; chooseMap.value = true}),
          name: _ctx.$t('translatorPage.map'),
          class: "w-full flex-1",
          outlined: "",
          disabled: chooseList.value
        }, null, 8, ["name", "disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex-1 w-full md:pr-6 lg:block", {'hidden': !chooseList.value}])
        }, [
          (translator.value?.advanceInfo?.absence?.isAbsence && translator.value?.advanceInfo?.absence?.message)
            ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                _createElementVNode("p", _hoisted_30, _toDisplayString(translator.value?.advanceInfo?.absence?.message), 1)
              ]))
            : _createCommentVNode("", true),
          (!translator.value?.basicInfo?.hasAccount || (translator.value?.basicInfo?.hasAccount && !translator.value?.advanceInfo?.aboutMe))
            ? (_openBlock(), _createElementBlock("section", _hoisted_31, [
                _createElementVNode("h2", _hoisted_32, _toDisplayString(_ctx.$t('translatorPage.aboutTranslator')), 1),
                _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t('translatorPage.aboutTranslatorContent')), 1)
              ]))
            : _createCommentVNode("", true),
          (!translator.value?.basicInfo?.hasAccount && !_unref(authHelper).isLogged())
            ? (_openBlock(), _createElementBlock("section", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t('translatorPage.signUpAsTranslatorInfo')), 1)
                  ]),
                  _createVNode(_component_router_link, {
                    to: {name: _unref(getRouteName)('registration'), query: {translator: true}}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ButtonPrimary, {
                        class: "w-full md:w-auto",
                        name: _ctx.$t('translatorPage.signUpAsTranslatorButton')
                      }, null, 8, ["name"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            : _createCommentVNode("", true),
          (translator.value?.basicInfo?.hasAccount && translator.value?.advanceInfo?.aboutMe)
            ? (_openBlock(), _createElementBlock("section", _hoisted_38, [
                _createElementVNode("h2", _hoisted_39, _toDisplayString(_ctx.$t('translatorPage.aboutMe')), 1),
                _createElementVNode("p", _hoisted_40, [
                  _createTextVNode(_toDisplayString(getAboutMeContent()) + " ", 1),
                  (translator.value?.advanceInfo?.aboutMe?.length > aboutMeLimit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "text-light-secondary underline pl-2",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showAllAboutMe.value = !showAllAboutMe.value), ["prevent"]))
                      }, _toDisplayString(showAllAboutMe.value ? _ctx.$t('translatorPage.showLess') : _ctx.$t('translatorPage.showMore')), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (translator.value?.basicInfo?.hasAccount && translator.value?.advanceInfo?.experiences && translator.value?.advanceInfo?.experiences.length > 0)
            ? (_openBlock(), _createElementBlock("section", _hoisted_41, [
                _createElementVNode("h2", _hoisted_42, _toDisplayString(_ctx.$t('translatorPage.experience')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTranslatorExperiencesArray(), (experienceData, experienceIndex) => {
                  return (_openBlock(), _createElementBlock("section", { key: experienceIndex }, [
                    _createElementVNode("p", _hoisted_43, _toDisplayString(experienceData?.where), 1),
                    _createElementVNode("p", _hoisted_44, [
                      _createElementVNode("span", _hoisted_45, _toDisplayString(getExperienceDate(experienceData?.dateFrom, experienceData?.dateTo)) + "・" + _toDisplayString(experienceData?.city), 1),
                      _createTextVNode(_toDisplayString(experienceData?.what), 1)
                    ])
                  ]))
                }), 128)),
                (translator.value?.advanceInfo?.experiences.length > experiencesShowLimit)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "underline text-light-secondary",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showAllExperience.value = !showAllExperience.value), ["prevent"]))
                    }, _toDisplayString(showAllExperience.value ? _ctx.$t('translatorPage.showLess') : _ctx.$t('translatorPage.showMore')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (translator.value?.basicInfo?.hasAccount && translator.value?.advanceInfo?.educations && translator.value?.advanceInfo?.educations.length > 0)
            ? (_openBlock(), _createElementBlock("section", _hoisted_46, [
                _createElementVNode("h2", _hoisted_47, _toDisplayString(_ctx.$t('translatorPage.education')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(translator.value?.advanceInfo?.educations, (educationData, educationIndex) => {
                  return (_openBlock(), _createElementBlock("section", { key: educationIndex }, [
                    _createElementVNode("p", _hoisted_48, _toDisplayString(educationData?.where), 1),
                    _createElementVNode("p", _hoisted_49, [
                      _createElementVNode("span", _hoisted_50, _toDisplayString(getEducationDate(educationData?.dateFrom, educationData?.dateTo)), 1),
                      _createTextVNode(_toDisplayString(educationData?.what), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(translator.value?.languages, (language, languageIndex) => {
            return (_openBlock(), _createElementBlock("section", {
              tabindex: "0",
              key: languageIndex,
              class: "bg-white p-6 w-full mb-2"
            }, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("h2", _hoisted_52, _toDisplayString(ucfirst(language?.name)), 1),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.$t('translatorPage.dateFrom')) + " " + _toDisplayString(language?.dateFrom), 1),
                  (language?.deadline > 0 && language?.deadlineValue)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          alt: _ctx.$t('translatorPage.clockIconAlt'),
                          class: "pr-2 translator-page-clock"
                        }, null, 8, _hoisted_56),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('translatorPage.deadline')) + ": " + _toDisplayString(language?.deadlineValue), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                (translator.value?.basicInfo?.hasAccount && language?.typeOfTranslations && language?.typeOfTranslations.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t('translatorPage.writtenTranslations')), 1),
                      _createElementVNode("ul", _hoisted_60, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(language?.typeOfTranslations, (typeOfTranslation, translationIndex) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: translationIndex,
                            class: "break-words"
                          }, _toDisplayString(typeOfTranslation.name), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (translator.value?.basicInfo?.hasAccount && language?.interpretation)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.$t('translatorPage.interpreting')), 1),
                      _createElementVNode("p", null, _toDisplayString(language?.interpretation ? _ctx.$t('translatorPage.yes') : _ctx.$t('translatorPage.no')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["lg:block lg:min-w-[517px] maps lg:w-auto", {'hidden' : !chooseMap.value, 'w-full': chooseMap.value}]),
          style: {"height":"800px"}
        }, [
          _createVNode(_component_GMapMap, {
            center: center.value,
            zoom: 12,
            style: {"width":"100%","height":"100%"},
            ref_key: "myMapRef",
            ref: myMapRef
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_GMapMarker, {
                key: _ctx.index,
                position: marker.value.position,
                clickable: true,
                draggable: false,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (openMarker(marker.value.id))),
                icon: marker.value.icon
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_GMapInfoWindow, {
                    ref: "infoWindow",
                    opened: openedMarkerID.value === marker.value?.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", {
                          class: "absolute top-1 right-2 cursor-pointer",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (closeInfo(0)))
                        }, "x"),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              (translator.value?.basicInfo?.profileImgUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: translator.value?.basicInfo?.profileImgUrl,
                                    alt: _ctx.$t('translatorPage.translatorImageAlt'),
                                    class: "!min-w-[56px] !max-w-[56px] translator-image-small md:block self-baseline"
                                  }, null, 8, _hoisted_67))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: _imports_0,
                                    alt: _ctx.$t('translatorPage.translatorImageAlt'),
                                    class: "!min-w-[56px] !max-w-[56px] translator-image-small md:block self-baseline w-full"
                                  }, null, 8, _hoisted_68))
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("h3", _hoisted_71, _toDisplayString(translator.value?.basicInfo?.name), 1),
                                (translator.value?.basicInfo?.hasAccount
                                                            && (
                                                                translator.value?.basicInfo?.stars
                                                                || translator.value?.basicInfo?.successfulOrders
                                                                || translator.value?.basicInfo?.isVip
                                                            ))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                      (translator.value?.basicInfo?.hasAccount && translator.value?.basicInfo?.stars)
                                        ? (_openBlock(), _createBlock(StarsCounter, {
                                            key: 0,
                                            stars: translator.value?.basicInfo?.stars,
                                            class: "pr-2"
                                          }, null, 8, ["stars"]))
                                        : _createCommentVNode("", true),
                                      (translator.value?.basicInfo?.hasAccount && translator.value?.basicInfo?.successfulOrders)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            class: "pr-3",
                                            "aria-label": _ctx.$t('translatorCard.votesNumber') + ' ' + translator.value?.basicInfo?.successfulOrders
                                          }, " (" + _toDisplayString(translator.value?.basicInfo?.successfulOrders) + ") ", 9, _hoisted_73))
                                        : _createCommentVNode("", true),
                                      (translator.value?.basicInfo?.hasAccount && translator.value?.basicInfo?.isVip)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_74, "VIP"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(translator.value?.languages, (lang, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "flex gap-2 flex-wrap flex-col sm:flex-row sm:items-center"
                                  }, [
                                    _createElementVNode("span", _hoisted_76, _toDisplayString(lang?.name), 1),
                                    ((lang.dateFrom) || (lang?.deadline > 0 && lang?.deadlineValue))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                          (lang.dateFrom)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(_ctx.$t('translatorCard.dateFrom')) + " " + _toDisplayString(lang.dateFrom), 1))
                                            : _createCommentVNode("", true),
                                          (lang?.deadline > 0 && lang?.deadlineValue)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                                _hoisted_80,
                                                _createElementVNode("p", null, _toDisplayString(lang?.deadlineValue), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_81, [
                            _hoisted_82,
                            _createElementVNode("p", _hoisted_83, _toDisplayString(translator.value?.address?.fullAddress), 1)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["opened"])
                ]),
                _: 1
              }, 8, ["position", "icon"]))
            ]),
            _: 1
          }, 8, ["center"])
        ], 2)
      ])
    ]),
    (Object.keys(translator.value).length && _unref(auth).isLogged())
      ? (_openBlock(), _createBlock(SendInquiriesModal, {
          key: 0,
          modelValue: showTranslatorRequestModal.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showTranslatorRequestModal).value = $event)),
          translator: translator.value,
          onCancel: cancel
        }, null, 8, ["modelValue", "translator"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})